import { render } from "./login-pwd.vue?vue&type=template&id=560d8d45"
import script from "./login-pwd.vue?vue&type=script&lang=js"
export * from "./login-pwd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__